import { Slider } from "./Slider";
export class HSlider extends Slider {
    constructor(skin = null) {
        super(skin);
        this.isVertical = false;
    }
}
